module.exports = "/_next/static/images/1143483a1c67212513913e31baa8d757-perks-15x.jpg.webp";